module.exports = __webpack_public_path__ + "static/img/defaultImg.44bf3e6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/defaultImg.png
// module id = MKWg
// module chunks = 26